import $ from 'jquery';

function mobilePrimaryNavigation() {

  const $menuToggle = $('.js-menuToggle');
  const $navigation = $('.js-navigation');
  const $header = $('.c-head');

  $menuToggle.on('click', function(evt) {
    evt.preventDefault();

    $navigation.toggleClass('is-active');
    $header.toggleClass('is-fixed');

    const isOpen = $navigation.hasClass('is-active');
    $(this).attr('aria-expanded', String(isOpen));

    $(window).on('resize', function () {
      if ($(this).width() >= 1024) {
        $navigation.removeClass('is-active');
        $header.removeClass('is-fixed');
        $menuToggle.attr('aria-expanded', 'false');
      }
    });
  });

}

export default mobilePrimaryNavigation;
